import type { ReactNode } from "react";
import { LinedTabs, type LinedTabsItem } from "ui-kit/src/LinedTabs/LinedTabs";
import { CUSTOM_GROUP_KEY, InsightEventGroupEnum } from "./constants";
import Icon from "../../../../../admin/src/components/Icon";

interface LinedTabsAdapterProps {
	active: InsightEventGroupEnum;
	children?: ReactNode;
	onChange?: (key: InsightEventGroupEnum) => void;
	tabs: LinedTabsItem[];
	iconSuffix?: string;
}

function StatsLinedTabsAdapter({
	tabs,
	active,
	children,
	onChange,
	iconSuffix,
}: LinedTabsAdapterProps) {
	const handleChange = (key: string) => {
		onChange?.(key as InsightEventGroupEnum);
	};

	const filteredTabs = tabs.map((tab) => {
		if (tab.key.includes(CUSTOM_GROUP_KEY)) {
			return { ...tab, hidden: true };
		}
		return tab;
	});

	return (
		<LinedTabs items={filteredTabs} active={active} onChange={handleChange}>
			{children}
			{iconSuffix && <Icon icon={iconSuffix} size={12} color="dark-grey" />}
		</LinedTabs>
	);
}

export { StatsLinedTabsAdapter };
